<div class="cashier-container" [appLoading]="loading">
  <div #cashier id="cashier"></div>
</div>
